export default "__VITE_ASSET__DMiD$RxG__"